<template>
  <div class="space-between-y">
    <input-item label="用户名">
      <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
    </input-item>
    <input-item label="姓名">
      <el-input v-model="form.fullname" placeholder="请输入姓名"></el-input>
    </input-item>
    <input-item label="请选择角色">
      <el-select multiple clearable filterable v-model="form.roleIds">
        <el-option v-for="(role,index) in option.roles" :key="index" :label="role.name" :value="role.id"></el-option>
      </el-select>
    </input-item>
    <input-item label="请选择团队">
      <el-select v-model="form.dealerId" placeholder="请选择" :filterable="true" :clearable="true">
        <el-option v-for="(item,index) in option.teams" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </input-item>
    <input-item label="身份">
      <el-select v-model="form.dealerUserRole">
        <el-option v-for="(item,index) in option.dealerUserRoles" :label="item.name" :value="item.value"
                   :key="index"></el-option>
      </el-select>
    </input-item>

    <el-button type="primary" @click="save()">保存</el-button>
  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import {role} from "@/api/role";
import {user} from "@/api/user";

export default {
  name: 'UserForm',
  components: {InputItem},

  props: {
    user: Object
  },

  data() {
    return {
      form: {
        id: "",
        username: "",
        roleIds: [],
        dealerId: "",
        dealerUserRole: "",
      },

      option: {
        roles: [],
        dealerUserRoles: [{
          name: "管理员", value: "manager"
        },
          {
            name: "销售", value: "sales"
          }, {
            name: "执行人员", value: "builder"
          }],
        teams: [],

      },

    };
  },

  created() {
    role.listAll().then(roles => {
      this.option.roles = roles;
    });
    this.form = JSON.parse(JSON.stringify(this.user));

    user.listAllDealer().then(res => {
      this.option.teams = res.data.map(item => {
        return {
          id: item.id.toString(),
          name: item.name
        }
      });
    })
  },

  methods: {
    save() {
      user.updateStaff(this.form).then(res => {
        if (res.code === 200) {
          this.$message.success("保存成功");
          this.$emit("updated");
        }
      });
    },
  },


};
</script>

<style scoped>
</style>
